import { LOAD_CONFIG, SAVE_CONFIG, RESET_CONFIG, COURSES_LOADED } from '../types';
import defaultConfig from '../../config/defaultConfig.json';

export default function (config = defaultConfig, action) {
  switch (action.type) {
    case LOAD_CONFIG:
      const newConfig = {
        main: { ...config.main, ...action.config.main },
        player: { ...config.player, ...action.config.player },
        loaded: true,
        coursesLoaded: config.coursesLoaded,
      };
      return newConfig;
    case SAVE_CONFIG:
      return action.config;
    case RESET_CONFIG:
      return defaultConfig;
    case COURSES_LOADED:
      return { ...config, coursesLoaded: action.payload }
    default:
      return config;
  }
}
